import { useMemo } from "react";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import ListItem from "./ListItem";

const List = ({ attr, data = [], noData, elementId, selectedElement, drag, css, listItemCss, multiple = false, ...rest }) => {
    const hasValue = (data) => {
        return data !== undefined || data !== null;
    }
    const list = useMemo(() => (
        <div className={`list-group ${css}`}>
            {data.map((element, index) => {
                if (element.hidden) {
                    return null;
                }

                const id = (elementId ? element[elementId] : element._id);
                const active = multiple ? selectedElement.includes(id) : selectedElement === id;

                return <ListItem
                    value={hasValue(element[attr]) ? element[attr] : noData}
                    index={index}
                    dataElement={elementId ? element[elementId] : element._id}
                    key={index}
                    item={element}
                    active={active}
                    drag={drag}
                    css={listItemCss}
                    {...rest}
                />;
            })}
        </div>
    ), [attr, data, noData, elementId, selectedElement, multiple, drag, css, listItemCss, rest]);

    if (drag) {
        return (
            <DndProvider backend={HTML5Backend}>
                {list}
            </DndProvider>
        );
    }

    return list;
};

export default List;